import React, { Component } from 'react';
import { Card, DropdownMenu, ListItem, Switch } from 'react-md';
import ReactEcharts from 'react-echarts-component';
import ZDropdownMenu from '../Utility/ZDropdownMenu';
import MetricsCardItem from './MetricsCardItem';
import MetricsSortItem from './MetricsSortItem';
import MetricsFilterItem from './MetricsFilterItem';
import MetricsCompareItem from './MetricsCompareItem';
import MetricsChartMenuItem from './MetricsChartMenuItem';
import MetricsGoalItem from './MetricsGoalItem';
import MetricsContestItem from './MetricsContestItem';
import ChartHelper from '../Helper/ChartHelper';
import AdvertisementService from '../../services/AdvertisementService';
import MetricsEngageErrorItem from './MetricsEngageErrorItem';

export default class MetricsViewCentral extends Component {

    constructor(props) {
        super(props);

        this.state = {
            rem: null,
            activeChart: "rollup",
            isSideBySide: window.localStorage.isSideBySide != undefined ? (window.localStorage.isSideBySide === 'true') : false,
            chartHidden: window.localStorage.chartHidden != undefined ? (window.localStorage.chartHidden === 'true') : false,
            contentId: -1,
            adImage: "",
            adLink: "",
            lastRemCount: 0,
            lazyScrollStart: 0,
            expandedGoal: null,
            expandedContest: null,
            scrollDown: 0

        }
        this.chartHelper = new ChartHelper();
        this.viewOuter = null;
        //this.chartClass = 'metrics-central-chart-card-container';
        this.chartLineCrossed = false;
        this.adService = new AdvertisementService();

        // Scroll Settings
        this.isScrolling = false;
        this.activeScrollTop = 0;
        this.scrollTopPrev = 0;
        this.scrollDownCounter = 0;
        this.lazyScrollUpperThreshold = 65;
        this.lazyScrollLength = 35;
        this.scrollIntervalDelay = 12;
        this.scrollDownThreshold = Math.floor(250 / this.scrollIntervalDelay);
        this.cardHeight = 4.6;
        this.cardCount = 3;
        this.chunkHeight = parseFloat((this.cardHeight * this.cardCount).toFixed(1));


        this.expandGoal = this.expandGoal.bind(this);
        this.expandContest = this.expandContest.bind(this);

        this.chartExists = this.chartExists.bind(this);
        this.numberWithCommas = this.numberWithCommas.bind(this);
        this.convertToDisplay = this.convertToDisplay.bind(this);

        this.handleScrollEvent = this.handleScrollEvent.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleInfinityScroll = this.handleInfinityScroll.bind(this);

        this.handleChangeChart = this.handleChangeChart.bind(this);
        this.toggleSideBySide = this.toggleSideBySide.bind(this);
        this.toggleChartHidden = this.toggleChartHidden.bind(this);
        this.generateBlastItems = this.generateBlastItems.bind(this);
        this.generateSortMenuItems = this.generateSortMenuItems.bind(this);
        this.generateGoalItems = this.generateGoalItems.bind(this);
        this.generateContestItems = this.generateContestItems.bind(this);
        this.openAdLink = this.openAdLink.bind(this);

        this.renderPhone = this.renderPhone.bind(this);
        this.renderDesktop = this.renderDesktop.bind(this);

        let self = this;
        self.adService.getContent((content) => {
            self.setState({ contentId: content.contentId, adImage: content.imageUrl, adLink: content.linkUrl });
            self.advertisementInterval = setInterval(() => {

                if (!window.zzIsPaused/* && this.props.isPhone*/) {
                    self.adService.getContent((content) => {
                        self.setState({ contentId: content.contentId, adImage: content.imageUrl, adLink: content.linkUrl });
                    });
                }
            }, 30000);
        });


        // self.scrollInterval = setInterval(() => {
        //     if (self.isScrolling) {
        //         self.handleScroll();
        //     }
        // }, self.scrollIntervalDelay);
    }

    componentDidMount() {

    }

    componentDidUpdate() {
        try {
            var el = document.getElementsByClassName("test-chart-short")[0];
            if (el !== undefined && el !== null) {
                el.firstElementChild.classList.add("rollup-bar-chart-zindex");
            }
        } catch (er) {
        }
    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {
        clearInterval(this.advertisementInterval);
    }

    expandGoal(goal) {
        this.setState({ expandedGoal: (this.state.expandedGoal === null ? goal : (this.state.expandedGoal.goalId === goal.goalId ? null : goal)) });
    }

    expandContest(contest) {
        this.setState({ expandedContest: (this.state.expandedContest === null ? contest : (this.state.expandedContest.contestId === contest.contestId ? null : contest)) });
    }

    chartExists() {
        return (this.props.screenContext.hasCharts && this.props.screenContext.screen != 'emps' && this.props.screenContext.screen != 'allemps')
    }

    numberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    convertToDisplay(type, number) {

        let endText = '';
        switch (type) {
            case 'MNY':
                endText += '$' + this.numberWithCommas(number);
                break;
            case 'INT':
                let newNum = parseFloat(number);
                if (newNum === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(0));
                }
                break;
            case 'PCT':
                let newNum1 = parseFloat(number);
                if (newNum1 === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(1)) + '%';
                }
                break;
            default:
                endText += this.numberWithCommas(number);
        }
        return endText;
    }

    handleChangeChart(chartName) {
        this.setState({ activeChart: chartName });
    }

    handleScrollEvent(e) {
        this.setState({ scrollDown: e.target.scrollTop });
        this.activeScrollTop = e.target.scrollTop;
        this.handleScroll(e.target.scrollTop);
        // this.isScrolling = true;
    }

    async handleScroll(eventScrollTop) {

        var self = this;
        let activeScrollTop = eventScrollTop === undefined ? self.activeScrollTop : eventScrollTop;

        try {

            let rem = parseFloat(getComputedStyle(document.documentElement).fontSize);

            if (this.props.isPhone) {
                if (this.chartExists()) {

                    var where = activeScrollTop / (12.75 * rem);
                    var style = {};
                    if (where <= 0) {

                        if (this.chartEl.style.transition != 'height 0.25s ease-in-out 0s, top 0.2s ease-in-out 0s') {
                            setTimeout(() => {
                                self.chartEl.style.transition = 'height 0.25s ease-in-out 0s, top 0.2s ease-in-out 0s';
                            }, 250);
                        }

                        this.chartEl.classList.remove('metrics-central-chart-card-container--active');
                    } else if (where >= 1) {

                        this.chartEl.style.transition = 'top 0.25s ease-in-out 0s, left 0.25s ease-in-out 0s,  transform 0.25s ease-in-out 0s';

                        this.chartEl.classList.add('metrics-central-chart-card-container--active');
                    } else {

                        if (this.chartEl.style.transition != 'height 0.25s ease-in-out 0s, top 0.2s ease-in-out 0s') {
                            setTimeout(() => {
                                self.chartEl.style.transition = 'height 0.25s ease-in-out 0s, top 0.2s ease-in-out 0s';
                            }, 250);
                        }

                        this.chartEl.classList.remove('metrics-central-chart-card-container--active');
                    }
                }
            }

            this.props.handleScrollTop(activeScrollTop <= 0, activeScrollTop);


            if (activeScrollTop != this.scrollTopPrev) {

                let tmpIsScrollDown = activeScrollTop > this.scrollTopPrev;

                if (tmpIsScrollDown) {
                    if (++this.scrollDownCounter >= this.scrollDownThreshold) {
                        self.scrollDownCounter = 0;
                        self.props.handleScrollDirection(tmpIsScrollDown);
                    }
                } else {
                    if (activeScrollTop < this.scrollTopPrev) {
                        self.scrollDownCounter = 0;
                    }
                    self.props.handleScrollDirection(tmpIsScrollDown);
                }
            }

            this.scrollTopPrev = activeScrollTop;

            this.handleInfinityScroll(rem);

        } catch (ex) {
        }

        // this.isScrolling = false;
    }

    handleInfinityScroll(rem) {
        var self = this;

        let threshold = this.lazyScrollUpperThreshold;
        let thresholdAdd = this.props.activeGoals.length * 5.5 + this.props.activeContests.length * 4.7;
        if (this.state.expandedGoal != null) {
            thresholdAdd += 11.35;
        }
        if (this.state.expandedContest != null) {
            thresholdAdd += 12.15;
        }
        threshold += thresholdAdd;


        let remCount = self.scrollTopPrev / rem;
        if (remCount >= threshold && (remCount >= self.state.lastRemCount + self.chunkHeight || remCount <= self.state.lastRemCount - self.chunkHeight)) {
            let lazyScrollStart = Math.floor((remCount - threshold) / self.cardHeight);
            let lastRemCount = threshold + (lazyScrollStart * self.cardHeight);
            self.setState({ lazyScrollStart: lazyScrollStart, lastRemCount: lastRemCount });
        } else if (remCount < threshold && self.state.lazyScrollStart != 0) {
            self.setState({ lazyScrollStart: 0, lastRemCount: 0 });
        }
    }

    toggleSideBySide() {

        window.localStorage.setItem('isSideBySide', !this.state.isSideBySide);
        this.setState({ isSideBySide: !this.state.isSideBySide });
    }

    toggleChartHidden() {

        if (this.state.chartHidden) {
            this.chartEl.classList.remove('metrics-chart-hidden');
        } else {
            this.chartEl.classList.add('metrics-chart-hidden');
        }

        window.localStorage.setItem('chartHidden', !this.state.chartHidden);

        this.setState({ chartHidden: !this.state.chartHidden });
    }

    generateBlastItems() {
        if (this.props.screenContext.groupKey === undefined ||
            this.props.blastData[this.props.screenContext.groupKey] === undefined) {
            return null;
        }

        let cMetric = this.props.blastData[this.props.screenContext.groupKey];

        let workingFlag = false;
        if (this.props.screenContext.screen === 'emps' || this.props.screenContext.screen === 'allemps') {
            for (var i = 0; i < cMetric.length; i++) {
                if (cMetric[i].isWorking) {
                    workingFlag = true;
                }
            }
        }

        let cMetricItems = [];

        let lazyTopStyle = {
            height: 4.6 * this.state.lazyScrollStart + 'rem',
            width: '100%'
        };
        let lazyBottomStyle = {
            width: '100%'
        };
        let remainingCount = 0;

        cMetricItems.push(<div style={lazyTopStyle}></div>)

        for (var i = 0; i < cMetric.length; i++) {

            if (i >= this.state.lazyScrollStart) {
                if (i < this.state.lazyScrollStart + this.lazyScrollLength) {
                    cMetricItems.push((<MetricsEngageErrorItem type='card' screenContext={this.props.screenContext}>
                        <MetricsCardItem
                            key={cMetric[i].uId}
                            accountInfo={this.props.accountInfo}
                            hasDistricts={this.props.hasDistricts}
                            changeScreen={this.props.changeScreen}
                            changeScreenLong={this.props.changeScreenLong}
                            promptForLongData={this.props.promptForLongData}
                            isSideBySide={this.state.isSideBySide}
                            selectedItems={this.props.selectedItems}
                            toggleSelectedItem={this.props.toggleSelectedItem}
                            rotateDataMode={this.props.rotateDataMode}
                            dataMode={this.props.blastFilter.dataMode}
                            range={this.props.blastFilter.range}
                            isMetric={this.props.screenContext.isMetric}
                            screenContext={this.props.screenContext}
                            identity={cMetric[i]}
                            workingFlag={workingFlag}
                            isGroupsMode={this.props.isGroupsMode}
                        />
                    </MetricsEngageErrorItem>));
                } else {
                    remainingCount++;
                }
            }
        }

        lazyBottomStyle.height = remainingCount * 4.6 + 'rem';

        cMetricItems.push(<div style={lazyBottomStyle}></div>)

        return cMetricItems;
    }

    generateSortMenuItems() {
        let sortMenuItems = [];

        if (this.props.screenContext.screen != 'loc' && this.props.screenContext.screen != 'emp' && this.props.screenContext.screen != 'allemp' && false /*Killing until someone complains I guess*/) {
            sortMenuItems.push((<MetricsSortItem onClick={this.props.changeSort} set="NAME" filter={this.props.blastFilter} icon="sort_by_alpha" text="Name" add={null} />));
            sortMenuItems.push((<MetricsSortItem onClick={this.props.changeSort} set="cY" filter={this.props.blastFilter} icon="sort" text="Current Year" add={null} />));
            sortMenuItems.push((<MetricsSortItem onClick={this.props.changeSort} set="lY" filter={this.props.blastFilter} icon="sort" text="Last Year" add={null} />));

            sortMenuItems.push((
                <ZDropdownMenu
                    id="metrics-central-filter-button-container"
                    className="metrics-central-filter-button-container"
                    menuItems={[
                        <MetricsFilterItem closeMenuOnClick onClick={this.props.handleSearchTop.bind(null, 0)} searchTop={this.props.searchTop} num={0} text="All" />,
                        <MetricsFilterItem closeMenuOnClick onClick={this.props.handleSearchTop.bind(null, 10)} searchTop={this.props.searchTop} num={10} text="First 10" />,
                        <MetricsFilterItem closeMenuOnClick onClick={this.props.handleSearchTop.bind(null, 25)} searchTop={this.props.searchTop} num={25} text="First 25" />,
                        <MetricsFilterItem closeMenuOnClick onClick={this.props.handleSearchTop.bind(null, 100)} searchTop={this.props.searchTop} num={100} text="First 100" />
                    ]}
                    isBlocked={true}
                >
                    <MetricsSortItem set="" filter={this.props.blastFilter} icon="filter_list" text="Filter" add={null} />
                </ZDropdownMenu>
            ));
        }

        let timeText = "";
        switch (this.props.blastFilter.range) {
            case "CUR": timeText = "Day"; break;
            case "WTD": timeText = "Week"; break;
            case "MTD": timeText = "Month"; break;
            case "QTD": timeText = "Quarter"; break;
            case "YTD": timeText = "Year"; break;
        }

        if (!this.props.isGroupsMode) {

            sortMenuItems.push((<MetricsCompareItem
                closeMenuOnClick
                style={{}}
                compareFunction={this.props.setCompareMode}
                compareMode={"lastYear"}
                icon={"equalizer"}
                text={(timeText === "Day" ? "Selected Date" : timeText + " to Date")}
                subtext={"Year Over Year"}
            />));

            sortMenuItems.push((<MetricsCompareItem
                closeMenuOnClick
                style={{}}
                compareFunction={this.props.setCompareMode}
                compareMode={"toDateLastPeriod"}
                icon={"equalizer"}
                text={(timeText === "Day" ? "Selected Date" : timeText + " to Date")}
                subtext={"Previous " + timeText}
            />));

            sortMenuItems.push((<MetricsCompareItem
                closeMenuOnClick
                style={{}}
                compareFunction={this.props.setCompareMode}
                compareMode={"endOfLastPeriod"}
                icon={"equalizer"}
                text={"Entire " + timeText}
                subtext={"Previous " + timeText}
            />));

            sortMenuItems.push((<MetricsCompareItem
                closeMenuOnClick
                style={{}}
                compareFunction={this.props.setCompareMode}
                compareMode={"thisDayLastPeriod"}
                icon={"equalizer"}
                text={"Same Day"}
                subtext={"Previous " + timeText}
            />));

            if (zzDataCache.targets != undefined && zzDataCache.targets != null && zzDataCache.targets.generalTarget != null) {

                sortMenuItems.push((<MetricsCompareItem
                    closeMenuOnClick
                    style={{ borderBottom: 'solid 1px rgba(0, 0, 0, 0.08)' }}
                    compareFunction={this.props.setCompareMode}
                    compareMode={"targets"}
                    icon={"gps_fixed"}
                    text={"Compare to Targets"}
                />));
            }
        }

        sortMenuItems.push((<MetricsSortItem style={{ padding: '0 0.7rem 0 0' }} set="" filter={this.props.blastFilter} icon="swap_horiz" text="Classic Mode" add={
            (<Switch
                id="switch-sort-menu"
                type="switch"
                name="sidebyside"
                defaultChecked={window.localStorage.isSideBySide != undefined ? (window.localStorage.isSideBySide === 'true') : false}
                value={this.state.isSideBySide}
                onChange={this.toggleSideBySide}
            />)
        } />));

        return sortMenuItems;
    }

    generateChartMenuItems() {
        let chartMenuItems = [];
        chartMenuItems.push((<MetricsChartMenuItem closeMenuOnClick onClick={this.handleChangeChart} chart="rollup" icon="short_text" text="Snapshot" add={null} />));
        chartMenuItems.push((<MetricsChartMenuItem closeMenuOnClick onClick={this.handleChangeChart} chart="bar" icon="equalizer" text="Bar Chart" add={null} />));
        //chartMenuItems.push((<MetricsChartMenuItem closeMenuOnClick onClick={this.handleChangeChart} chart="pie" icon="pie_chart" text="Pie Chart" add={null} />));
        chartMenuItems.push((<MetricsChartMenuItem closeMenuOnClick onClick={this.toggleChartHidden} icon="swap_vert" text="Collapse Chart" add={null} />));

        if (this.state.scrollDown > 50) {
            chartMenuItems = null;
        }
        return chartMenuItems;
    }

    generateGoalItems() {

        let goals = [];

        for (var i = 0; i < this.props.activeGoals.length; i++) {

            let numType = 'INT';
            if (this.props.activeGoals[i].blastData != undefined && this.props.activeGoals[i].blastData != null && this.props.activeGoals[i].blastData.length > 0) {
                numType = this.props.activeGoals[i].blastData[0].type;
            }
            // if (this.props.blastData[this.props.activeGoals[i].metricName] != undefined && this.props.blastData[this.props.activeGoals[i].metricName].length != 0) {
            //     numType = this.props.blastData[this.props.activeGoals[i].metricName][0].type;
            // } else {

            // }

            goals.push((<MetricsEngageErrorItem type='goal'>
            <MetricsGoalItem
                // key={this.props.activeGoals[i].name + "|" + this.props.lastBlastReload}
                key={"goalId" + this.props.activeGoals[i].goalId}
                allBlastData={this.props.blastData}
                locationMap={this.props.locationMap}
                storeMap={this.props.storeMap}
                numType={numType}
                identity={this.props.activeGoals[i]}
                selectedDate={this.props.blastFilter.date}
                expandGoal={this.expandGoal}
                expanded={this.state.expandedGoal === null ? false : this.state.expandedGoal.goalId === this.props.activeGoals[i].goalId}
            />
            </MetricsEngageErrorItem>));
        }

        return goals;
    }

    generateContestItems() {
        let contests = [];

        let activeContestant = zzDataCache.myDataName === undefined ? null : zzDataCache.myDataName;
        let activeContestantScreens = ['emp', 'allemp']
        if (activeContestantScreens.includes(this.props.screenContext.screen)) {
            activeContestant = this.props.screenContext.groupKey;
        }

        let isBlurred = false;
        if (this.props.accountInfo != undefined && this.props.accountInfo != null && this.props.accountInfo.userType === 5) {
            isBlurred = this.props.accountInfo.isEmployeeBlurred === null ? false : this.props.accountInfo.isEmployeeBlurred;
        }

        for (var i = 0; i < this.props.activeContests.length; i++) {

            let expanded = this.state.expandedContest === null ? false : this.state.expandedContest.contestId === this.props.activeContests[i].contestId;

            let tmpActiveContestant = activeContestant;
            if (this.props.activeContests[i].identity.participantType === "loc" && ["distLoc", "loc"].includes(this.props.screenContext.screen)) {
                tmpActiveContestant = this.props.screenContext.groupKey;
            }

            contests.push((<MetricsEngageErrorItem type='contest'>
            <MetricsContestItem
                key={this.props.activeContests[i].contestId + "|" + this.props.lastBlastReload}
                contest={this.props.activeContests[i]}
                expandContest={this.expandContest}
                expanded={expanded}
                activeContestant={tmpActiveContestant}
                isBlurred={isBlurred}
                myDataName={zzDataCache.myDataName}
            />
            </MetricsEngageErrorItem>));
        }

        return contests;
    }

    renderChart(chartTitleText) {
        if (!this.chartExists()) {
            return null;
        }

        let chart = null;
        let dropDownJsx = null;
        let range = this.props.blastFilter.range;
        let dataMode = this.props.blastFilter.dataMode;
        let screen = this.props.screenContext.screen;
        let groupKey = this.props.screenContext.groupKey;
        let keys = Object.keys(this.props.blastData);
        let cNums = [];
        let lNums = [];
        let lNumsD = [];
        let lNumsP = [];
        let xNames = [];
        let singleBlastData;

        let fullQty = 0;

        let tmpType = '';
        let tmpIsAvg = false;
        if (keys.length > 0 && groupKey != undefined && this.props.blastData[groupKey] != undefined) {
            singleBlastData = this.props.blastData[groupKey];

            if (singleBlastData.length > 0) {
                tmpType = singleBlastData[0].type;
                tmpIsAvg = singleBlastData[0].isAvg;
            }

            let tempData = [];
            for (var i = 0; i < singleBlastData.length; i++) {
                for (var j = 0; j < this.props.selectedItems.length; j++) {
                    if (singleBlastData[i].name === this.props.selectedItems[j].name) {
                        tempData.push(singleBlastData[i]);
                    }
                }
            }

            let data = (this.props.selectedItems.length > 0 ? tempData : singleBlastData);

            if (screen === "dists" && (tmpType === 'PCT' || tmpIsAvg)) {
                cNums = _.map(data, (obj) => { return obj.cData[range] * obj.zzQty });
                lNums = _.map(data, (obj) => { return obj.lData[range] * obj.zzQty });
                lNumsD = _.map(data, (obj) => { return obj.lDataD[range] });
                lNumsP = _.map(data, (obj) => { return obj.lDataP[range] });
                xNames = _.map(data, (obj) => { return obj.name });
            } else {
                cNums = _.map(data, (obj) => { return obj.cData[range] });
                lNums = _.map(data, (obj) => { return obj.lData[range] });
                lNumsD = _.map(data, (obj) => { return obj.lDataD[range] });
                lNumsP = _.map(data, (obj) => { return obj.lDataP[range] });
                xNames = _.map(data, (obj) => { return obj.name });
            }

            fullQty = data.reduce((r, e) => { if (e.zzQty != undefined) { r += e.zzQty } return r; }, 0);
        }

        let xAxisJsx = null;
        let yAxisJsx = null;

        if (this.state.activeChart === 'bar') {
            let xIcon = null;
            let yIcon = null;

            switch (dataMode) {
                case 'N':
                    chart = this.chartHelper.generateProgressBarChart(xNames, cNums, lNums);
                    yIcon = '#'
                    break;
                case 'D':
                    yIcon = '+/-'
                    chart = this.chartHelper.generatePosNegBarChart(xNames, lNumsD);
                    break;
                case 'P':
                    yIcon = '%'
                    chart = this.chartHelper.generatePosNegBarChart(xNames, lNumsP);
                    break;
            }

            switch (this.props.screenContext.screen) {
                case 'locs':
                    xIcon = 'store_mall_directory';
                    break;
                case 'emps':
                    xIcon = 'person';
                    break;
                case 'allemps':
                    xIcon = 'person';
                    break;
            }

            xAxisJsx = <div className="material-icons chart-axis-icon-x">{xIcon}</div>
            yAxisJsx = <div className="chart-axis-icon-y">{yIcon}</div>

        } else if (this.state.activeChart === 'rollup') {
            switch (dataMode) {
                case 'N':
                    chart = this.chartHelper.generateRollupBarChart(cNums, lNums);
                    break;
                case 'D':
                    chart = this.chartHelper.generateRollupBarChart(cNums, lNums);
                    break;
                case 'P':
                    chart = this.chartHelper.generateRollupBarChart(cNums, lNums);
                    break;
            }

            chart.props.className = chart.props.className + " progress-bar-chart-container";

            let cyTotal = parseFloat(cNums.reduce((total, num) => { return total + num; }, 0).toFixed(2));
            let lyTotal = parseFloat(lNums.reduce((total, num) => { return total + num; }, 0).toFixed(2));

            if (tmpType === 'PCT' || tmpIsAvg) {
                if (screen === "dists") {
                    cyTotal = parseFloat((cyTotal / (fullQty > 0 ? fullQty : 1)).toFixed(2));
                    lyTotal = parseFloat((lyTotal / (fullQty > 0 ? fullQty : 1)).toFixed(2));
                } else {
                    cyTotal = parseFloat((cyTotal / (cNums.length > 0 ? cNums.length : 1)).toFixed(2));
                    lyTotal = parseFloat((lyTotal / (lNums.length > 0 ? lNums.length : 1)).toFixed(2));
                }
            }


            let perc = parseFloat(((cyTotal / lyTotal) * 100.0).toFixed(1)) - 100.0;
            if (isNaN(parseFloat(perc))) {
                perc = 0;
            } else if (!isFinite(perc)) {
                perc = 0;
            }
            perc = perc.toFixed(1);
            if (perc >= 0) {
                perc = '+' + perc;
            }
            let percClass = "right";
            perc += '%';

            let delta = parseFloat((cyTotal - lyTotal).toFixed(2));
            let deltaText = tmpType === 'PCT' ? Math.abs(delta).toFixed(1) + '' : this.convertToDisplay(tmpType, Math.abs(delta));
            if (delta >= 0) {
                deltaText = '+' + deltaText;
            } else {
                deltaText = '-' + deltaText;
            }

            let bottomRightSubClass = "bottom-right-sub";
            let subLabel = "LY";
            if (zzDataCache.settings.compareMode === "endOfLastPeriod" ||
                zzDataCache.settings.compareMode === "toDateLastPeriod" ||
                zzDataCache.settings.compareMode === "thisDayLastPeriod") {
                subLabel = "LP";
            } else if (zzDataCache.settings.compareMode === "targets") {
                subLabel = "gps_fixed";
                bottomRightSubClass = 'material-icons ' + bottomRightSubClass;
            }

            xAxisJsx = (
                <div className="chart-rollup-sub">
                    <div className="top-left-label">{'+/-'}</div>
                    <div className="bottom-left-label">{'%'}</div>
                    <div className="top-left">{deltaText}</div>
                    <div className="bottom-left">{perc}</div>
                    <div className="top-right">{this.convertToDisplay(tmpType, cyTotal)}<div className="top-right-sub">CY</div></div>
                    <div className="bottom-right">{this.convertToDisplay(tmpType, lyTotal)}<div className={bottomRightSubClass}>{subLabel}</div></div>
                    {/* <div className={percClass}>{perc}</div> */}
                </div>
            );

        } else if (this.state.activeChart === 'pie') {
            switch (dataMode) {
                case 'N':
                    chart = this.chartHelper.generateDoublePieChart(xNames, cNums, lNums);
                    break;
                case 'D':
                    chart = this.chartHelper.generateDoublePieChart(xNames, cNums, lNums);
                    break;
                case 'P':
                    chart = this.chartHelper.generateDoublePieChart(xNames, cNums, lNums);
                    break;
            }
        }

        let chartClass = 'metrics-central-chart-card-container';
        if (!this.state.chartHidden) {
            dropDownJsx = (
                <ZDropdownMenu
                    id="metrics-central-title-button-container"
                    className="metrics-central-title-button-container"
                    menuItems={this.generateChartMenuItems()}
                    isBlocked={true}
                    scrollDown={this.state.scrollDown}
                // anchor={{
                //     x: DropdownMenu.HorizontalAnchors.INNER_RIGHT,
                //     y: DropdownMenu.VerticalAnchors.OVERLAP
                // }}
                // repositionOnScroll={false}
                >
                    <div className="metrics-central-title-button material-icons">more_vert</div>
                </ZDropdownMenu>
            );
        } else {
            chartClass += ' metrics-chart-hidden';
            dropDownJsx = (
                <div className="metrics-central-title-button-container" onClick={this.toggleChartHidden}><div className="metrics-central-title-button material-icons">swap_vert</div></div>
            );
        }

        return (
            <div className={chartClass} ref={(el) => { this.chartEl = el; }} onClick={this.props.scrollToTop}>
                <div className="metrics-central-title-container">
                    <div className="metrics-central-title">{chartTitleText}</div>
                    {dropDownJsx}
                </div>
                <div className="metrics-central-chart-container">
                    {chart}
                </div>
                {xAxisJsx}
                {yAxisJsx}
            </div>
        );
    }

    openAdLink() {
        if (this.state.adLink != '#' && this.state.adLink != '') {
            this.adService.clickContent(this.state.contentId);
            if (window.hasOwnProperty('cordova')) {
                cordova.InAppBrowser.open(this.state.adLink, '_system');
            }
            else {
                window.open(this.state.adLink, '_system');
            }
        }
    }

    render() {

        if (this.props.blastData === undefined || Object.keys(this.props.blastData).length === 0 ||
            this.props.blastData[this.props.screenContext.groupKey] === undefined || this.props.blastData[this.props.screenContext.groupKey].length === 0) {
            return (
                <div className="metrics-central-outer" ref={(outer) => { this.viewOuter = outer }} style={this.props.style} onScroll={this.handleScrollEvent}>
                    <div className="error-message-outer">
                        <div className="error-image-container">
                            <div className="error-image material-icons">equalizer</div>
                        </div>
                        <div className="error-message-container">
                            <div className="error-message">Metrics Data for Selected Date Not Found</div>
                        </div>
                    </div>
                </div>
            );
        }

        if (this.props.isPhone) {
            return this.renderPhone();
        } else {
            return this.renderDesktop();
        }
    }

    renderPhone() {
        let titleText = "";

        let timeText = "";
        switch (this.props.blastFilter.range) {
            case "CUR": timeText = "Day"; break;
            case "WTD": timeText = "Week"; break;
            case "MTD": timeText = "Month"; break;
            case "QTD": timeText = "Quarter"; break;
            case "YTD": timeText = "Year"; break;
        }

        // switch (zzDataCache.settings.compareMode) {
        //     case "lastYear": titleText = "Last Year " + (timeText === "Day" ? "Daily" : timeText + " to Date"); break;
        //     case "endOfLastPeriod": titleText = "Last Period End of " + timeText; break;
        //     case "toDateLastPeriod": titleText = "Last Period " + (timeText === "Day" ? "" : timeText + " ") + "to Date"; break;
        //     case "thisDayLastPeriod": titleText = "This Day Last " + (timeText === "Day" ? "Period" : timeText); break;
        //     case "targets": titleText = timeText + " Targets"; break;
        // }
        switch (zzDataCache.settings.compareMode) {
            case "lastYear": titleText = "Year Over Year"; break;
            case "toDateLastPeriod": titleText = (timeText === "Day" ? "Previous Day" : timeText + " to Date"); break;
            case "endOfLastPeriod": titleText = "Entire " + timeText; break;
            case "thisDayLastPeriod": titleText = "Same Day"; break;
            case "targets": titleText = timeText + " Targets"; break;
        }

        let regTitleText = this.props.screenContext.headerText + " (" + titleText + ")";

        var chart = this.renderChart(titleText);
        let blastItems = this.generateBlastItems();

        let sortMenuItems = this.generateSortMenuItems();

        let topSpacerClass = 'metrics-central-chart-spacer';
        let bottomSpacerClass = 'metrics-central-chart-spacer';
        if (this.state.chartHidden) {
            topSpacerClass += ' spacer-hidden';
        } else {
            bottomSpacerClass += ' spacer-hidden';
        }

        let spacer = null;
        if (this.chartExists()) {
            spacer = <div className={topSpacerClass}></div>;
        }

        let isBlurred = false;
        if (this.props.accountInfo != undefined && this.props.accountInfo != null && this.props.accountInfo.userType === 5) {
            isBlurred = this.props.accountInfo.isEmployeeBlurred === null ? false : this.props.accountInfo.isEmployeeBlurred;
        }

        let personJsx = null;
        if (!isBlurred && this.props.accountInfo != undefined && this.props.accountInfo != null && (this.props.screenContext.screen === 'emp' || this.props.screenContext.screen === 'allemp')) {

            let personIdentity = this.props.blastData[this.props.screenContext.groupKey];

            if (personIdentity != undefined && personIdentity.length > 0) {

                let onlineClass = "metrics-card-item-icon-online";
                if (personIdentity[0].isWorking) {
                    onlineClass += ' background-emerald';
                }

                let tmpPhone = 'No Phone Listed';
                let hardPhone = personIdentity[0].phone;
                if (hardPhone === undefined || hardPhone === null || hardPhone === '') {
                    for (var i = 0; i < this.props.employeePhoneList.length; i++) {
                        if (this.props.employeePhoneList[i].name === this.props.screenContext.groupKey) {
                            hardPhone = this.props.employeePhoneList[i].phone;
                        }
                    }
                }
                if (hardPhone != undefined && hardPhone != null && hardPhone != '') {
                    tmpPhone = hardPhone;
                    if (!isNaN(tmpPhone) && tmpPhone.length === 10) {
                        tmpPhone = tmpPhone.substring(0, 3) + '-' + tmpPhone.substring(3, 6) + '-' + tmpPhone.substring(6, tmpPhone.length);
                    }
                }

                let tmpStoreList = [];
                for (var i = 0; i < personIdentity.length; i++) {
                    if (!tmpStoreList.includes(personIdentity[i].storeId)) {
                        tmpStoreList.push(personIdentity[i].storeId);
                    }
                }

                let tmpStoreName = '';
                if (tmpStoreList.length > 1) {
                    tmpStoreName = 'Multi-Location';
                } else if (tmpStoreList.length === 1) {
                    tmpStoreName = this.props.storeMap[personIdentity[0].storeId];
                }

                tmpStoreName = personIdentity[0].locationName;

                let avatarImage = (personIdentity[0].avatarUrl === undefined || personIdentity[0].avatarUrl === null) ?
                    (<div className="material-icons metrics-card-item-icon">person</div>)
                    :
                    (<div className="material-icons metrics-card-item-icon"
                        onClick={() => { alert((<img className="alert-avatar-image" src={personIdentity[0].avatarUrl} onError={(e) => { e.target.style.display = 'none' }} />)) }}
                    >
                        person
                        <img className="avatar-image" src={personIdentity[0].avatarUrl} onError={(e) => { e.target.style.display = 'none' }} />
                    </div>);


                personJsx = (
                    <div className="metrics-central-regular-card-container">
                        <div className="metrics-card-item-outer">
                            <div className="metrics-card-item-icon-container">
                                {avatarImage}
                                <div className={onlineClass}></div>
                            </div>
                            <div className="metrics-card-name-container" style={{ width: 'calc(100% - 11rem)' }}>
                                <div className="metrics-card-name-person">{tmpPhone}</div>
                                <div className="metrics-card-subname-person">{tmpStoreName}</div>
                            </div>
                            {this.props.meKey === this.props.screenContext.groupKey ? null : (
                                <div className="metrics-card-call-container">
                                    <div className="material-icons cellcall" style={{ color: tmpPhone === 'No Phone Listed' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.55)' }} onClick={this.props.callPeople}>smartphone</div>
                                    <div className="material-icons cellcall" style={{ color: tmpPhone === 'No Phone Listed' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.55)' }} onClick={this.props.textPeople}>chat</div>
                                </div>
                            )}
                        </div>
                    </div>
                );
            }
        }

        let goalCards = this.generateGoalItems();
        let contestCards = this.generateContestItems();

        let statusSortText = null;
        switch (this.props.blastFilter.sortBy) {
            case 'NAME': statusSortText = 'Name';
                break;
            case 'cY': statusSortText = 'Current Year';
                break;
            case 'lY': statusSortText = 'Last Year';
                break;
            default: statusSortText = 'Default';
        }
        let statusSortDirStyle = {
            transform: 'rotateX(0deg)'
        };
        if (this.props.blastFilter.sortByDir != 'DESC') {
            statusSortDirStyle = {
                transform: 'rotateX(180deg)'
            };
        }

        let statusFilterText = null;
        if (this.props.searchTop === 0) {
            statusFilterText = 'All';
        } else if (this.props.searchTop != undefined && this.props.searchTop != null) {
            statusFilterText = 'First ' + this.props.searchTop;
        }

        let outerClass = "metrics-central-outer";
        if (this.props.isScrollDirectionDown) {
            outerClass += " metrics-central-outer-expanded";
        }
        if (this.props.drillingIn != 'still') {
            if (this.props.drillingIn === 'forward') {
                outerClass += " metrics-central-outer-drill-in";
            } else if (this.props.drillingIn === 'back') {
                outerClass += " metrics-central-outer-drill-out";
            }
        }

        let statusBarStyle = {};
        if (this.props.screenContext.screen === 'loc' || this.props.screenContext.screen === 'emp' || this.props.screenContext.screen === 'allemp') {
            statusBarStyle.height = '0rem';
        }

        return (
            <div className={outerClass} ref={(outer) => { this.viewOuter = outer }} style={this.props.style} onScroll={this.handleScrollEvent}>
                <div className="metrics-central-topbar-spacer"></div>
                {spacer}
                {chart}
                {personJsx}
                {contestCards}
                {goalCards}
                <div className="metrics-central-regular-card-container">
                    <div className="metrics-central-title-container">
                        <div className="metrics-central-title">{regTitleText}</div>
                        <ZDropdownMenu
                            id="metrics-central-title-button-container"
                            className="metrics-central-title-button-container"
                            menuItems={sortMenuItems}
                            isBlocked={true}
                        >
                            <div className="metrics-central-title-button material-icons">more_vert</div>
                        </ZDropdownMenu>
                    </div>
                    <div className="metrics-central-status-container" style={statusBarStyle}>
                        <div className="metrics-central-status-sort">
                            {/* <div className="metrics-central-status-type" onClick={this.props.rotateDataMode}>{this.props.blastFilter.dataMode === 'N' ? '#' : (this.props.blastFilter.dataMode === 'P' ? '%' : '+/-')}</div> */}
                            <div className="material-icons metrics-central-status-icon">sort</div>
                            <div className="metrics-central-status-sortname" onClick={this.props.rotateSort}>{statusSortText + " " + (this.props.blastFilter.dataMode === 'N' ? '#' : (this.props.blastFilter.dataMode === 'P' ? '%' : '+/-'))}</div>
                            <div className="material-icons metrics-central-status-sortarrow" onClick={this.props.rotateSortDir} style={statusSortDirStyle}>arrow_downward</div>
                        </div>
                        <div className="metrics-central-status-filter">
                            <div className="metrics-central-status-sortname" onClick={this.props.rotateFilter}>{statusFilterText}</div>
                            <div className="material-icons metrics-central-status-icon">filter_list</div>
                        </div>
                    </div>
                    {blastItems}
                </div>
                <div className="metrics-central-regular-card-container">
                    <img onClick={this.openAdLink} className="metrics-central-advertisement-card" src={this.state.adImage} />
                </div>
                <div className="spacer-short"></div>
            </div>
        );
    }

    renderDesktop() {

        let titleText = "";

        let timeText = "";
        switch (this.props.blastFilter.range) {
            case "CUR": timeText = "Day"; break;
            case "WTD": timeText = "Week"; break;
            case "MTD": timeText = "Month"; break;
            case "QTD": timeText = "Quarter"; break;
            case "YTD": timeText = "Year"; break;
        }

        // switch (zzDataCache.settings.compareMode) {
        //     case "lastYear": titleText = "Last Year " + (timeText === "Day" ? "Daily" : timeText + " to Date"); break;
        //     case "endOfLastPeriod": titleText = "Last Period End of " + timeText; break;
        //     case "toDateLastPeriod": titleText = "Last Period " + (timeText === "Day" ? "" : timeText + " ") + "to Date"; break;
        //     case "thisDayLastPeriod": titleText = "This Day Last " + (timeText === "Day" ? "Period" : timeText); break;
        //     case "targets": titleText = timeText + " Targets"; break;
        // }
        switch (zzDataCache.settings.compareMode) {
            case "lastYear": titleText = "Year Over Year"; break;
            case "toDateLastPeriod": titleText = (timeText === "Day" ? "Previous Day" : timeText + " to Date"); break;
            case "endOfLastPeriod": titleText = "Entire " + timeText; break;
            case "thisDayLastPeriod": titleText = "Same Day"; break;
            case "targets": titleText = timeText + " Targets"; break;
        }

        let regTitleText = this.props.screenContext.headerText + " (" + titleText + ")";

        let blastItems = this.generateBlastItems();

        let sortMenuItems = this.generateSortMenuItems();

        let topSpacerClass = 'metrics-central-chart-spacer';
        let bottomSpacerClass = 'metrics-central-chart-spacer';
        if (this.state.chartHidden) {
            topSpacerClass += ' spacer-hidden';
        } else {
            bottomSpacerClass += ' spacer-hidden';
        }

        let isBlurred = false;
        if (this.props.accountInfo != undefined && this.props.accountInfo != null && this.props.accountInfo.userType === 5) {
            isBlurred = this.props.accountInfo.isEmployeeBlurred === null ? false : this.props.accountInfo.isEmployeeBlurred;
        }

        let personJsx = null;
        if (!isBlurred && this.props.accountInfo != undefined && this.props.accountInfo != null && (this.props.screenContext.screen === 'emp' || this.props.screenContext.screen === 'allemp')) {

            let personIdentity = this.props.blastData[this.props.screenContext.groupKey];

            if (personIdentity != undefined && personIdentity.length > 0) {

                let onlineClass = "metrics-card-item-icon-online";
                if (personIdentity[0].isWorking) {
                    onlineClass += ' background-emerald';
                }

                let tmpPhone = 'No Phone Listed';
                let hardPhone = personIdentity[0].phone;
                if (hardPhone === undefined || hardPhone === null || hardPhone === '') {
                    for (var i = 0; i < this.props.employeePhoneList.length; i++) {
                        if (this.props.employeePhoneList[i].name === this.props.screenContext.groupKey) {
                            hardPhone = this.props.employeePhoneList[i].phone;
                        }
                    }
                }
                if (hardPhone != undefined && hardPhone != null && hardPhone != '') {
                    tmpPhone = hardPhone;
                    if (!isNaN(tmpPhone) && tmpPhone.length === 10) {
                        tmpPhone = tmpPhone.substring(0, 3) + '-' + tmpPhone.substring(3, 6) + '-' + tmpPhone.substring(6, tmpPhone.length);
                    }
                }

                let tmpStoreList = [];
                for (var i = 0; i < personIdentity.length; i++) {
                    if (!tmpStoreList.includes(personIdentity[i].storeId)) {
                        tmpStoreList.push(personIdentity[i].storeId);
                    }
                }

                let tmpStoreName = '';
                if (tmpStoreList.length > 1) {
                    tmpStoreName = 'Multi-Location';
                } else if (tmpStoreList.length === 1) {
                    tmpStoreName = this.props.storeMap[personIdentity[0].storeId];
                }

                tmpStoreName = personIdentity[0].locationName;

                let avatarImage = (personIdentity[0].avatarUrl === undefined || personIdentity[0].avatarUrl === null) ?
                    (<div className="material-icons metrics-card-item-icon">person</div>)
                    :
                    (<div className="material-icons metrics-card-item-icon"
                        onClick={() => {personIdentity[0].avatarUrl === '' ? null : alert((<img className="alert-avatar-image" src={personIdentity[0].avatarUrl} onError={(e) => { e.target.style.display = 'none' }} />)) }}
                    >
                        person
                        <img className="avatar-image" src={personIdentity[0].avatarUrl} onError={(e) => { e.target.style.display = 'none' }} /></div>);


                personJsx = (
                    <div className="metrics-central-regular-card-container">
                        <div className="metrics-card-item-outer">
                            <div className="metrics-card-item-icon-container">
                                {avatarImage}
                                <div className={onlineClass}></div>
                            </div>
                            <div className="metrics-card-name-container" style={{ width: 'calc(100% - 11rem)' }}>
                                <div className="metrics-card-name-person">{tmpPhone}</div>
                                <div className="metrics-card-subname-person">{tmpStoreName}</div>
                            </div>
                            {this.props.meKey === this.props.screenContext.groupKey ? null : (
                                <div className="metrics-card-call-container">
                                    <div className="material-icons cellcall" style={{ color: tmpPhone === 'No Phone Listed' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.55)' }} onClick={this.props.callPeople}>smartphone</div>
                                    <div className="material-icons cellcall" style={{ color: tmpPhone === 'No Phone Listed' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.55)' }} onClick={this.props.textPeople}>chat</div>
                                </div>
                            )}
                        </div>
                    </div>
                );
            }
        }

        let statusSortText = null;
        switch (this.props.blastFilter.sortBy) {
            case 'NAME': statusSortText = 'Name';
                break;
            case 'cY': statusSortText = 'Current Year';
                break;
            case 'lY': statusSortText = 'Last Year';
                break;
            default: statusSortText = 'Default';
        }
        let statusSortDirStyle = {
            transform: 'rotateX(0deg)'
        };
        if (this.props.blastFilter.sortByDir != 'DESC') {
            statusSortDirStyle = {
                transform: 'rotateX(180deg)'
            };
        }

        let statusFilterText = null;
        if (this.props.searchTop === 0) {
            statusFilterText = 'All';
        } else if (this.props.searchTop != undefined && this.props.searchTop != null) {
            statusFilterText = 'First ' + this.props.searchTop;
        }

        let outerClass = "metrics-central-outer";

        if (this.props.drillingIn != 'still') {
            if (this.props.drillingIn === 'forward') {
                outerClass += " metrics-central-outer-drill-in";
            } else if (this.props.drillingIn === 'back') {
                outerClass += " metrics-central-outer-drill-out";
            }
        }

        let statusBarStyle = {};
        if (this.props.screenContext.screen === 'loc' || this.props.screenContext.screen === 'emp' || this.props.screenContext.screen === 'allemp') {
            statusBarStyle.height = '0rem';
        }

        return (
            <div className={outerClass} ref={(outer) => { this.viewOuter = outer }} style={this.props.style} onScroll={this.handleScrollEvent}>
                <div className="metrics-central-topbar-spacer"></div>
                {personJsx}
                <div className="metrics-central-regular-card-container">
                    <div className="metrics-central-title-container">
                        <div className="metrics-central-title">{regTitleText}</div>
                        <ZDropdownMenu
                            id="metrics-central-title-button-container"
                            className="metrics-central-title-button-container"
                            menuItems={sortMenuItems}
                            isBlocked={true}
                        >
                            <div className="metrics-central-title-button material-icons">more_vert</div>
                        </ZDropdownMenu>
                    </div>
                    <div className="metrics-central-status-container" style={statusBarStyle}>
                        <div className="metrics-central-status-sort">
                            <div className="material-icons metrics-central-status-icon">sort</div>
                            <div className="metrics-central-status-sortname" onClick={this.props.rotateSort}>{statusSortText + " " + (this.props.blastFilter.dataMode === 'N' ? '#' : (this.props.blastFilter.dataMode === 'P' ? '%' : '+/-'))}</div>
                            <div className="material-icons metrics-central-status-sortarrow" onClick={this.props.rotateSortDir} style={statusSortDirStyle}>arrow_downward</div>
                        </div>
                        <div className="metrics-central-status-filter">
                            <div className="metrics-central-status-sortname" onClick={this.props.rotateFilter}>{statusFilterText}</div>
                            <div className="material-icons metrics-central-status-icon">filter_list</div>
                        </div>
                    </div>
                    {blastItems}
                </div>
                <div className="metrics-central-regular-card-container">
                    <img onClick={this.openAdLink} className="metrics-central-advertisement-card" src={this.state.adImage} />
                </div>
            </div>
        );
    }
}